export default Object.freeze({
  CANCEL_POP_TITLE: '취소처리내역',
  EXCHANGE_POP_TITLE: '교환처리내역',
  RETURN_POP_TITLE: '반품처리내역',
  CANCEL_PRODUCT: '취소상품',
  CANCEL_EXCHANGE_PRODUCT: '교환취소상품',
  RETURN_EXCHANGE_PRODUCT: '교환반품상품',
  RETURN_PRODUCT: '반품상품',

  CANCEL_NOTICE_WAIT_DEPOSIT: '‘입금대기’상품의 주문취소 시 전체취소만 가능하며, 별도의 환불처리 절차가 필요 없습니다.',
  CANCEL_NOTICE_PG:
    '간편결제 또는 PG결제건은 취소금액만큼 부분취소 처리됩니다. 단, 일부 신용카드 또는 휴대폰결제 등 경우에 따라 부분취소가 안될 경우 환불방법을 ‘현금환불’로 변경하여 현금으로 환불처리 해주세요.',
  CANCEL_NOTICE_DEPOSIT: '무통장입금/가상계좌 입금건은 반드시 환불절차를 완료해주세요.',
  CANCEL_NOTICE_PREPARE_DELIVERY: '상품준비중/배송준비중 상품을 취소신청 할 경우 파트너사의 출고여부 확인 절차 후 취소처리됩니다.',
  NOTICE_VIRTUAL_ACCOUNT: '가상계좌 주문 건의 경우, PG환불 처리 시 PG사 정책에 따라 환불 수수료가 부과될 수 있습니다. 사용 중인 PG사 측으로 사전 문의 부탁드립니다.',

  WITHDRAW: '철회',
  CONFIRM_DEPOSIT: '입금확인',
  REFUND_PROCESS: '환불처리',
  CANCEL_WITHDRAW: '취소신청 철회',
  CANCEL_ACCEPT: '취소승인',
  MODIFY_SAVE: '변경사항 저장',
  CLOSE: '닫기',
  SELLER_COLLECT: '판매자수거요청',
  BUYER_DIRECT_RETURN: '구매자직접반품',
  AFTER_CLAIM_NOS: '후순위 클레임 번호',

  ASK_REFUND_MESSAGE: '환불처리 하시겠습니까?',
  ASK_WITHDRAW_MESSAGE: '철회하시겠습니까?',
  ASK_AMOUNT_CHANGED_WITHDRAW_MESSAGE: '철회 시 후순위 클레임의 결제/환불 금액이 변동됩니다.\n클레임을 철회하시겠습니까?',
  ASK_ACCEPT_CANCEL: '반드시 판매자를 통해 상품출고 여부를 확인 후 진행하세요!\n취소승인 처리하시겠습니까?',
  PROCESS_SUCCESS_MESSAGE: '처리되었습니다.',

  CLAIM_NO: '클레임번호',
  REFUND_EXPECTATION_AMOUNT: '환불 예상 금액',
  REFUND_AMOUNT: '환불 금액',
  REFUND_A_PLUS_B: '환불금액 ⓐ+ⓑ',
  REFUND_A_MINUS_B_PLUS_C: '환불금액 ⓐ-ⓑ+ⓒ',
  REFUND_EXPECTATION_A_PLUS_B: '환불예상금액 ⓐ+ⓑ',
  REFUND_EXPECTATION_A_MINUS_B_PLUS_C: '환불예상금액 ⓐ-ⓑ+ⓒ',
  REFUND_EXPECTATION_A_MINUS_B_PLUS_C_MINUS_D: '환불예상금액 ⓐ-ⓑ+ⓒ-ⓓ',
  ACCUMULATION_REFUND: '적립금사용반환',
  CARD_CANCEL_REFUND_AMOUNT: '카드취소/현금환불액',
  REFUND_TYPE: '환불방법',
  PG_EXCESS: 'PG초과',
  NONE_REFUND_AMOUNT: '환불금액없음',
  REFUND_ACCOUNT: '환불계좌번호',
  ACCOUNT: '계좌번호',
  DEPOSITOR_NAME: '예금주',
  EXCHANGE_PRODUCT_IMAGE: '교환반품 이미지',
  RETURN_PRODUCT_IMAGE: '반품 이미지',

  EXCHANGE_RELEASE_PRODUCT: '교환출고상품',

  BENEFIT_RECALCULATE: '지급(예정)혜택재계산',
  POINT_RECALCULATE: '지급(예정)적립금재계산',
  AFTER_CHANGE: '변경후',
  BEFORE_CHANGE: '변경전',
  HOLD_PROCESSING: '보류중',
  CANCEL_DEPOSIT: '미입금 취소처리',

  CANCEL_AMOUNT_DETAIL: '취소상품 금액상세',
  RETURN_AMOUNT_DETAIL: '반품상품 금액상세',
  CANCEL_PRODUCT_AMOUNT: '취소상품금액',
  RETURN_PRODUCT_AMOUNT: '반품상품금액',
  PRODUCT_TOTAL_AMOUNT: '상품합계',
  ADDITIONAL_DISCOUNT: '추가할인',
  PRODUCT_COUPON_RECALCULATE: '상품쿠폰 재계산',
  CANCEL_AMOUNT_A: '취소금액합계 ⓐ',
  RETURN_AMOUNT_A: '반품금액합계 ⓐ',

  OPEN_AND_CLOSE: '열기/닫기',

  EXCHANGE_INFO: '교환정보',
  RETURN_INFO: '반품정보',

  EXCHANGE_WITHDRAW: '교환신청 철회',
  EXCHANGE_APPROVE: '교환승인',
  EXCHANGE_WITHDRAW_APPROVE: '교환반려신청승인',

  RETURN_WITHDRAW: '반품신청철회',
  RETURN_APPROVE: '반품 승인',
  RETURN_WITHDRAW_APPROVE: '반품반려신청승인',

  RETURN_APPLY_INFO: '반품접수정보',
  RETURN_INVOICE_PLACEHOLDER: '반품 송장번호 입력',
  DELIVERY_COMPANY_ALL_TXT: '배송업체',

  WAREHOUSE_ADDRESS: '출고지주소',
  RETURN_EXCHANGE_RELEASE_ADDRESS: '반품/교환지주소',
  FIRST_RELEASE_INFO: '최초출고정보',
  RETURN_COLLECT_INFO: '반품수거정보',

  EXCHANGE_PRODUCT_DIFFER_DETAIL: '교환상품 차액상세',

  EXCHANGE_PRODUCT_AMT: '교환상품금액',
  PRODUCT_SUM_DIFFER: '상품합계차액',

  EXCHANGE_PRODUCT: '교환상품',
  ADDITIONAL_DISCOUNT_DIFFER: '추가할인차액',
  AMOUNT_ADJUSTMENT: '금액조정(선택)',
  ADJUST_REASON: '조정사유',
  RETURN_WITHDRAW_REASON: '반품철회사유',

  EXCHANGE_RELEASE_INFO: '교환출고정보',
  EXCHANGE_NAVER_PAY_WITHRAW_HOLD: '네이버페이 교환보류 처리',
  RETURN_NAVER_PAY_WITHRAW_HOLD: '네이버페이 반품보류 처리',

  EXCHANGE_AMOUNT_SUM_A: '교환금액합계 ⓐ',
  DELIVERY_AMOUNT_SUM_B: '배송비합계 ⓑ',
  EXCHANGE_PROCESS_AMOUNT_A_PLUS_B: '교환처리금액 ⓐ+ⓑ',
  EXCHANGE_PROCESS_AMOUNT_A_PLUS_B_PLUS_C: '교환처리금액 ⓐ+ⓑ+ⓒ',
  REFUND_ADJUST_AMOUNT_D: '환불 금액조정 ⓓ',

  EXCHANGE_DELIVERY_AMOUNT_TITLE: '교환상품 배송비상세 및 조정',
  EXCHANGE_PROCESS_AMOUNT_TITLE: '교환처리금액',
  RETURN_DELIVERY_AMOUNT_TITLE: '반품상품 배송비상세 및 조정',
  CHANGE: '변경',
  RETURN_WAY_TYPE: '반품수거방법',
  DIVIDED: '나눔',
  COMBINED: '묶음',
  PARTNER_REFUND_HOLD_REASON: '파트너사 환불보류 신청 사유',
  PARTNER_ADJUST_REQUEST_AMOUNT: '파트너사 조정 요청 금액',
  FORMAT_ERROR_MESSAGE: '입력형식 오류',
  RESTORE_STOCK: '[재고복원예정]',
  RESTORE_STOCK_COMPLETE: '[재고복원완료]',

  DISCOUNT_DELIVERY_RECALCULATE: '할인/배송비재계산',
  DISCOUNT_AMOUNT_CHANGE_1: '할인금액변경 ①',
  COUPON_RECALCULATE: '주문쿠폰 재계산',
  COUPON_NO: '쿠폰번호',
  COUPON_NONE: '적용된 쿠폰 없음',
  TO_RECOVERY: '복원예정',
  TO_RECOVERY_COMPLETED: '복원완료',
  DELIVERY_CHANGE_2: '배송비변경 ②',
  DELIVERY_DIFFERENCE: '배송비차액',
  BEFORE_DELIVERY_AMOUNT: '변경전배송비',
  AFTER_DELIVERY_AMOUNT: '변경후배송비',
  PRE_PAID: '착불',
  DELIVERY_NO: '배송번호',
  SELLER_RESPONSIBLE: '판매자 부담',
  RECALCULATE_ONE_PLUS_TWO_B: '재계산합계 ①+②=ⓑ',
  RECALCULATE_ONE_PLUS_TWO_C: '재계산합계 ①+②=ⓒ',
  PREPAID_GUIDE: '착불 배송비 가이드',
  ASK_CONFIRM_DEPOSIT_MESSAGE: '입금확인하시겠습니까?',
  ASK_EXCHANGE_WITHDRAW_APPROVE: '교환반려신청승인하시겠습니까?',
  ASK_EXCHANGE_APPROVE: '교환승인하시겠습니까?',
  ASK_RETURN_APPROVE: '반품승인하시겠습니까?',
  ASK_RETURN_WITHDRAW_APPROVE: '반품반려신청 승인하시겠습니까?',
  ASK_ADJUSTMENT_AMOUNT_INITIALIZE: '환불 금액조정이 초기화 됩니다. 변경사항 저장 후 다시 입력해 주세요.',
  MODIFY_SUCCESS_MESSAGE: '변경사항이 저장되었습니다. 이후 클레임 단계를 진행해 주세요.',
  PREPAID_GUIDE_MESSAGE_ONE: '배송비는 상품에 적용된 배송비 템플릿의 ‘묶음그룹 > 결제방식 > 선결제/착불’ 설정에 따라 부과됩니다.',
  PREPAID_GUIDE_MESSAGE_TWO: '착불인 경우 발생하는 배송비는 표기되나 최종 금액에 반영되지 않습니다.',
  NONE_EXCHANGE_AMOUNT_MESSAGE: '교환처리 금액이 발생하지 않았습니다.',
  SHOPPING_MALL_RESPONSIBLE_MESSAGE: '※ 쇼핑몰 부담으로 조정됩니다.',
  CLAIM_NOT_FOUND_MESSAGE: '취소할 수 있는 상품이 없습니다.',
  MODIFY_ACCOUNT_VALID_MESSAGE: '환불계좌번호를 입력해 주세요.',
  MODIFY_DEPOSITOR_VALID_MESSAGE: '예금주를 입력해 주세요',
  MODIFY_ADJUSTMENT_REASON_VALID_MESSAGE: '조정사유를 입력해주세요',
  ADDITIONAL_PAY_REMITTER_VALID_MESSAGE: '입금자명을 입력해 주세요',
  DIVIDE_DELIVERY_MESSAGE: '나눔배송된 경우 원배송기준으로 재계산됩니다.',
  RECEIVER_EMPTY_VALID_MESSAGE: '수령자명을 입력하세요',
  CONTACT_EMPTY_VALID_MESSAGE: '휴대전화를 입력하세요',
  CONTACT_FORMAT_VALID_MESSAGE: '잘못된 휴대폰 번호입니다. 휴대폰 번호를 정확하게 입력하세요.',
  ADJUST_AMOUNT_EXCESS_VALID_MESSAGE: '금액조정은 환불예상금액을 초과할 수 없습니다.',
  ADJUST_AMOUNT_EXCESS_DELIVERY_AMOUNT_VALID_MESSAGE: '금액조정은 기본배송비와 지역별 추가배송비의 합을 초과할 수 없습니다.',
  ASK_EXCHANGE_WITH_HOLD: '교환보류 처리하시겠습니까?',
  ASK_RETURN_WITH_HOLD: '반품보류 처리하시겠습니까?',
  ASK_RETURN_RELEASE_HOLD: '반품보류 해제하시겠습니까?',
  ASK_EXCHANGE_RELEASE_HOLD: '교환보류 해제하시겠습니까?',

  NOTICE_NAVER_PAY_PREDICT_AMOUNT: '네이버페이 주문형 주문의 샵바이프리미엄 화면 내 금액은 예상 금액이며, 네이버페이의 조정 및 정책에 따라 변경될 수 있습니다.',
  NOTICE_NAVER_PAY_CENTER: '네이버페이 주문형 주문은 네이버페이 센터를 통해 상세 금액 및 내역을 확인해 주세요.',
  ALERT_NAVER_PAY_PROCESS_SUCCESS: '처리 요청되었습니다.',

  NAVER_PAY_WITH_HOLD_REASON_GUIDE: '보류 사유를 선택 후, 상세사유 입력 시 보류처리가 가능합니다.',
  NAVER_PAY_WITH_HOLD_ADJUSTMENT_GUIDE: '보류 조정 요청금액을 입력한 경우, 입력한 금액으로 조정 요청이 됩니다.',
  NAVER_PAY_WITH_HOLD_ADJUSTMENT_REQUIRE_GUIDE: '보류 사유 중 조정 요청금액을 필수로 입력해야 하는 경우, 금액을 입력해야 보류처리가 가능합니다.',
  NAVER_PAY_WITH_HOLD_RELEASE: '보류 처리 후, 보류해제를 해야 이후 주문상태로 변경이 가능합니다.',

  NAVER_PAY_EXCHANGE_WITH_HOLD_REASON: '교환보류 사유',
  NAVER_PAY_RETURN_WITH_HOLD_REASON: '반품보류 사유',

  NAVER_PAY_EXCHANGE_WITH_HOLD_REASON_DETAIL: '교환보류 사유',
  NAVER_PAY_RETURN_WITH_HOLD_REASON_DETAIL: '반품보류 사유',

  NAVER_PAY_EXCHANGE_WITH_HOLD_ADJUST_AMOUNT: '교환보류 조정 요청 금액',
  NAVER_PAY_RETURN_WITH_HOLD_ADJUST_AMOUNT: '반품보류 조정 요청 금액',

  WITH_HOLD_APPROVE: '보류 처리',

  PROC_COMPLETE_COLLECT: '수거완료 처리',
  TOOL_TIP_MESSAGE_SELECT_EXCHANGE_REMAIN: '수거완료 후 재고복원 여부를 선택해주세요.',
  TOOL_TIP_MESSAGE_SELECT_EXCHANGE_RESTORE: '수거완료 후 재고복원 신청한 경우 교환완료[환불완료] 시점 재고가 자동으로 복원 됩니다.',
  TOOL_TIP_MESSAGE_SELECT_RETURN_REMAIN: '환불보류가 필요한 경우 수거완료(환불보류) 항목을 선택해주세요.',
  TOOL_TIP_MESSAGE_SELECT_RETURN_RESTORE: '재고복원처리 체크한 경우 수거완료 후 반품완료[환불완료] 시점 재고가 자동으로 복원 됩니다.',
  ASK_COLLECT_COMPLETE_MESSAGE: '수거완료 처리하시겠습니까?',
  PRODUCT_NAME: '상품명',
  OPTION_NO: '옵션번호',
  OPTION_MANAGEMENT_CD: '옵션관리코드',
  STOCK_NO: '재고번호',
  PROC_RESTORE_STOCK: '재고복원 처리',
  REQUEST_COMPLETE: '신청완료',
  REFUND_ADJUSTMENT_AMOUNT: '환불보류 조정 요청금액',
  NUMBER_PLACER_HOLDER: '숫자만입력',
  REFUND_HOLD_REASON: '환불보류사유',
  COLLECT_RETURN_REASON_PLACE_HOLDER: '환불보류 사유를 입력해 주세요.',
  SELECT: '선택해주세요',
  COLLECT_COMPLETE_PROCESS: '수거완료(환불진행)',
  COLLECT_COMPLETE_HOLD: '수거완료(환불조정)',
  INPUT_DISABLE: '입력 안함',
  INPUT_ABLE: '입력함',
  SELECT_REFUND_ITEM_MESSAGE: '환불처리 항목을 선택해주세요.',
  WRITE_AMOUNT_MESSAGE: '금액을 입력해주세요.',
  WRITE_REFUND_REASON_MESSAGE: '환불보류사유를 입력해 주세요.',
  ASK_REFUND_HOLD_MESSAGE: '환불보류를 신청하시겠습니까?',

  BEFORE_8DAYS_ALERT: '렌탈결제 주문 건 반품 시, 배송완료 일자 기준 8일 이내로 클레임 완료 처리가 되어야 합니다. 배송완료 일자 기준 8일 이후 관리자 페이지에서 클레임 처리가  불가능하니 기간에 유의하여 클레임 처리 부탁 드립니다.',
  AFTER_8DAYS_ALERT: '배송완료 일자가 8일이 지난 렌탈결제 주문 건의 반품 클레임은 사용중인 렌탈 서비스 고객센터를 통해 처리 부탁드립니다.',
});
